import Agent from '../Core/agent';

const AuthApi = {
    recoverPassword: phone => {
        return Agent.post
        (
            `/api/auth/code/${phone}`,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },
    authorization: (userName, password) => {

        return Agent.post
        (
            `/api/auth/${userName}`,
            new window.URLSearchParams({
                password: password
            })
        );
    }
};
export default AuthApi;